import { IElement } from "core-integration/src/store/elements/types";
import { ITeam } from "core-integration/src/store/teams/types";
import { integerToMoney, isMoneyStat } from "core-integration/src/utils/money";
import { rgba } from "polished";
import * as React from "react";
import styled, { css } from "styled-components/";
import ElementDialogButton from "./ElementDialogButton";
import ElementInTable from "./ElementInTable";
import { ElementCell, ElementRow } from "./ElementTable";

const StyledElementListRow = styled(ElementRow)<IStyledProps>`
  ${(props) =>
    props.isProposed &&
    css`
      td,
      button {
        color: ${rgba("black", 0.6)};
      }

      img {
        opacity: 0.6;
      }
    `}
`;

const FlexElementCell = styled(ElementCell)`
  display: flex;
`;

interface IStyledProps {
  isProposed: boolean;
}

interface IProps extends IStyledProps {
  currencyDivisor: number;
  element: IElement;
  renderElementDialog: () => void;
  renderElementMenu: () => void;
  sort: string | number;
  team: ITeam;
}

const ElementListRow: React.FC<IProps> = ({
  currencyDivisor,
  element,
  isProposed,
  renderElementMenu,
  sort,
  team,
}) => (
  <StyledElementListRow isProposed={isProposed}>
    <FlexElementCell>
      <div>
        <ElementDialogButton elementId={element.id} variant="list" />
      </div>
      <ElementInTable
        renderElementMenu={renderElementMenu}
        element={element}
        team={team}
      />
    </FlexElementCell>
    <ElementCell $bold={true}>
      {integerToMoney(element.now_cost, currencyDivisor)}
    </ElementCell>
    <ElementCell $bold={true}>
      {isMoneyStat(sort)
        ? integerToMoney(element[sort] as number, currencyDivisor)
        : element[sort]}
    </ElementCell>
  </StyledElementListRow>
);

export default ElementListRow;
